import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import {
  BUYER_MODULE_VISIBILITY_EVENT,
  DEFAULT_BUYER_MODULE_VISIBILITY,
  normalizeBuyerModuleVisibility,
} from "@/lib/buyerModuleVisibility";

/**
 * Visibilidad de módulos operativos para compradores (rollout / en construcción).
 */
export function useBuyerModuleVisibility() {
  const [modules, setModules] = useState(DEFAULT_BUYER_MODULE_VISIBILITY);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/system/buyer-module-visibility");
      setModules(normalizeBuyerModuleVisibility(data?.modules));
    } catch {
      setModules(DEFAULT_BUYER_MODULE_VISIBILITY);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const onUpdate = () => {
      reload();
    };
    window.addEventListener(BUYER_MODULE_VISIBILITY_EVENT, onUpdate);
    return () => window.removeEventListener(BUYER_MODULE_VISIBILITY_EVENT, onUpdate);
  }, [reload]);

  return { modules, loading, reload };
}

export async function updateBuyerModuleVisibility(modules) {
  const { data } = await api.put("/system/buyer-module-visibility", {
    modules: normalizeBuyerModuleVisibility(modules),
  });
  window.dispatchEvent(new CustomEvent(BUYER_MODULE_VISIBILITY_EVENT));
  return data;
}
